// Este código opcional se usa para registrar un service worker.
// register() no se llama por defecto.

// Esto permite que la app cargue más rápido en visitas subsecuentes en producción, y da
// capacidades offline. Sin embargo, también significa que los desarrolladores (y usuarios)
// solo verán actualizaciones desplegadas en visitas subsecuentes a una página, después de que todas las
// pestañas existentes abiertas en la página hayan sido cerradas, ya que los recursos
// previamente cacheados se actualizan en segundo plano.

// Para aprender más sobre los beneficios de este modelo y instrucciones de cómo
// optar por él, lee https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] es la dirección localhost de IPv6.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 son consideradas localhost para IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // El constructor de URL está disponible en todos los navegadores que soportan SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Nuestro service worker no funcionará si PUBLIC_URL está en un origen diferente
      // de lo que nuestra página está servida. Esto puede pasar si se usa un CDN para
      // servir activos; mira https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // Esto está corriendo en localhost. Vamos a verificar si un service worker aún existe o no.
        checkValidServiceWorker(swUrl, config);

        // Agregar algunos logs adicionales para localhost, señalando a los desarrolladores a la
        // documentación del service worker/PWA.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'Esta aplicación web está siendo servida con cache-first por un service ' +
              'worker. Para aprender más, visita https://cra.link/PWA'
          );
        });
      } else {
        // No es localhost. Solo registrar service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // En este punto, el contenido precacheado actualizado ha sido obtenido,
              // pero el service worker anterior aún servirá el contenido anterior
              // hasta que todas las pestañas del cliente sean cerradas.
              console.log(
                'Nuevo contenido está disponible y será usado cuando todas ' +
                  'las pestañas de esta página sean cerradas. Mira https://cra.link/PWA.'
              );

              // Ejecutar callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // En este punto, todo ha sido precacheado.
              // Es el momento perfecto para mostrar un
              // mensaje "El contenido está cacheado para uso offline."
              console.log('El contenido está cacheado para uso offline.');

              // Ejecutar callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error durante el registro del service worker:', error);
    });
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
  // Verificar si el service worker puede ser encontrado. Si no puede recargar la página.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Asegurar que el service worker existe, y que realmente estamos obteniendo un archivo JS.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No se encontró service worker. Probablemente una app diferente. Recargar la página.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker encontrado. Proceder como normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No se encontró conexión a internet. La app está corriendo en modo offline.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

